/**
 * Entrypoint — marketing-only stack.
 * Изолированный entry для marketing.<домен>.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { AuthProvider } from "@/auth/AuthContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { PeriodProvider } from "@/state/period";
import { buildMarketingRouter } from "@/router.marketing";
import { bootstrapTheme } from "@/lib/useTheme";
import { setBrandFavicon } from "@/lib/setBrandFavicon";
import "@/styles/global.css";
import "@/styles/production-tg.css";

bootstrapTheme();
setBrandFavicon("marketing");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const router = buildMarketingRouter(queryClient);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("No #root element");

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <PeriodProvider>
            <RouterProvider router={router} />
          </PeriodProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
